import Vue from "vue";

let oldPartyId = '';

Vue.component("modifications-annex", {
    props: ["startdate", "enddate", "annexes", "partyId"],
    data() {
        return {
            loading: false,
            goodsLoading: false,
            serviceLoading: false,
            constructionServiceLoading: false,
            generalNoteLoading: false,
            offsetNoteLoading: false,
            generalNotes: [],
            offsetNotes: [],
            goods: [],
            services: [],
            constructionServices: [],
            isOpen: null
        };
    },
    computed: {
        entitiesLabel: function () {
            return window.labels.entities;
        },
        notesLabel: function () {
            return window.labels.notes;
        },
        footNotesLabel: function () {
            return window.labels.footnotes;
        },
        noteTypeNote: function () {
            return window.constants.noteType.note
        },
        noteTypeFootNote: function () {
            return window.constants.noteType.footnote
        }
    },
    methods: {
        getModifications(annexId, annexNumber) {
            const self = this;

            self.loading = true;
            if (annexNumber == 4) {
                self.searchGoods(annexId);
            }
            else if (annexNumber == 5) {
                self.searchServices(annexId);
            }
            else if (annexNumber == 6) {
                self.searchConstructionServices(annexId);
            }
            else if (annexNumber == 7 || annexNumber == 8) {
                self.searchNote(annexId, annexNumber == 7);
            }
            self.loading = false;
        },
        searchNote(annexId, generalNote) {
            const self = this;

            if (generalNote) {
                self.generalNoteLoading = true;
            }
            else {
                self.offsetNoteLoading = true;
            }
            self.$services.modification.searchNoteByAnnexAndPartyAndDateRange({
                searchParameterDateFrom: self.startdate,
                searchParameterDateTo: self.enddate,
                language: window.currentLanguage,
                annexId: annexId,
                noteType: window.constants.noteType.note
            }).then((data) => {
                if (generalNote) {
                    if (data.notes != null && data.notes.length > 0) {
                        self.generalNotes = data.notes;
                    }
                    self.generalNoteLoading = false;
                }
                else {
                    if (data.notes != null && data.notes.length > 0) {
                        self.offsetNotes = data.notes;
                    }
                    self.offsetNoteLoading = false;
                }
            });
        },
        searchGoods(annexId) {
            const self = this;

            self.goodsLoading = true;
            self.$services.modification.searchGoodByAnnexAndPartyAndDateRange({
                searchParameterDateFrom: self.startdate,
                searchParameterDateTo: self.enddate,
                language: window.currentLanguage,
                annexId: annexId
            }).then((data) => {
                if (data.goods != null && data.goods.length > 0) {
                    self.goods = data.goods;
                }                

                self.goodsLoading = false;
            });
        },
        searchServices(annexId) {
            const self = this;

            self.serviceLoading = true;
            self.$services.modification.searchServiceByAnnexAndPartyAndDateRange({
                searchParameterDateFrom: self.startdate,
                searchParameterDateTo: self.enddate,
                language: window.currentLanguage,
                annexId: annexId
            }).then((data) => {
                if (data.services != null && data.services.length > 0) {
                    self.services = data.services;
                }
                
                self.serviceLoading = false;
            });
        },
        searchConstructionServices(annexId) {
            const self = this;

            self.constructionServiceLoading = true;
            self.$services.modification.searchConstructionServiceByAnnexAndPartyAndDateRange({
                searchParameterDateFrom: self.startdate,
                searchParameterDateTo: self.enddate,
                language: window.currentLanguage,
                annexId: annexId
            }).then((data) => {
                if (data.constructionServices != null && data.constructionServices.length > 0) {
                    self.constructionServices = data.constructionServices;
                }
                
                self.constructionServiceLoading = false;
            });
        }
    },
    template: `
        <div>
	        <b-collapse                    
		        class="modification-card mb-2"
		        animation="slide"
		        v-for="(annex, index) of annexes"
		        :key="partyId + '_annex-' + annex.id"
		        :open="isOpen == (partyId + 'annexId' + annex.id)"
		        @@open="isOpen = (partyId + 'annexId' + annex.id)">
		        <template #trigger="props">
			        <div class="modification-card-annex-header" role="button" @click="getModifications(annex.id, annex.number)">
				        <div class="modification-card-annex-header-title" :id="'annex-' + annex.id">
                            <div v-html="annex.name"></div>
                            <div class="annex-number-display">(Annex {{ annex.number }})</div>
				        </div>
			        </div>                    
		        </template>
                <template v-if="loading"><loading></loading></template>
                <template v-else>
		            <div class="modification-card-content">                        
                        <modifications-annex-item :annex="annex" v-if="annex.hasModifiedEntity && annex.number <= 3" :forEntity="true" :annexItemLabel="entitiesLabel" :annexItem="partyId + '_entity-'" :startdate="startdate" :enddate="enddate"></modifications-annex-item>                        
                        <modifications-annex-item :annex="annex" v-if="annex.hasModifiedNote && annex.number <= 3" :forEntity="false" :noteType="noteTypeNote" :annexItemLabel="notesLabel" :annexItem="partyId +'_note-'" :startdate="startdate" :enddate="enddate"></modifications-annex-item>
                        <modifications-annex-item :annex="annex" v-if="annex.hasModifiedFootNote && annex.number <= 3" :forEntity="false" :noteType="noteTypeFootNote" :annexItemLabel="footNotesLabel" :annexItem="partyId + '_footNote-'" :startdate="startdate" :enddate="enddate"></modifications-annex-item>			                              
                        <template v-if="goodsLoading"><loading></loading></template>
                        <template v-else>
                            <modifications-parent v-if="(annex.number == 4 && (goods != null && goods.length > 0))" :parents="goods" ownerType="GOODS"></modifications-parent>
                        </template>
                        <template v-if="serviceLoading"><loading></loading></template>
                        <template v-else>
                            <modifications-parent v-if="(annex.number == 5 && (services != null && services.length > 0))" :parents="services" ownerType="SERVICE"></modifications-parent>
                        </template>
                        <template v-if="constructionServiceLoading"><loading></loading></template>
                        <template v-else>
                            <modifications-parent v-if="(annex.number == 6 && (constructionServices != null && constructionServices.length > 0))" :parents="constructionServices" ownerType="CONSTRUCTIONSERVICE"></modifications-parent>
                        </template>
                        <template v-if="generalNoteLoading"><loading></loading></template>
                        <template v-else>
                            <modifications-parent v-if="(annex.number == 7 && (generalNotes != null && generalNotes.length > 0))" :parents="generalNotes" ownerType="NOTE"></modifications-parent>
                            <modifications-annex-item :annex="annex" v-if="annex.number == 7" :forEntity="true" :annexItemLabel="entitiesLabel" :annexItem="partyId + '_entity_generalnote-'" :startdate="startdate" :enddate="enddate"></modifications-annex-item>
                        </template>
                        <template v-if="offsetNoteLoading"><loading></loading></template>
                        <template v-else>
                            <modifications-parent v-if="(annex.number == 8 && (offsetNotes != null && offsetNotes.length > 0))" :parents="offsetNotes" ownerType="NOTE"></modifications-parent>
                        </template>
		            </div>
                </template>
	        </b-collapse>
        </div>
	`
});

